import { useEffect, useRef, useState } from "react";
import api from "../api";
import { Toast } from "primereact/toast";
import { exitFromApplication, getIsOnline } from "../../utilities/common.utilities";
import LoadingSpinner from "../../components/loading-spinner/loading-spinner";

export default function ResponseInterceptor  ()  {
    const showError = (detail: string) => {
        toast.current?.show({ severity: 'error', summary: 'Errore', detail: detail });
    };

    const showErrorNoConnection = (detail: string) => {
      toast.current?.show({ severity: 'error', summary: 'Attenzione', detail: detail });
    };

    const toast = useRef<Toast>(null);
    const [statusLoader, setStatusLoader] = useState<boolean>(false);
  
  useEffect(() => {
    // intercetto la request dell'api
    const requestInterceptorId = api.interceptors.request.use( config => {

      console.log('Interceptor calling');

      setStatusLoader(true);

      return config;

    }, (error) => {
      return Promise.reject(error);
    })
    //intercetto la response dell'api
    const responseInterceptorId = api.interceptors.response.use( (response) => {
      
        setStatusLoader(false);
      
      return response;
    },
      async (error) => {
        setStatusLoader(false);
        // se è un errore gestito da backend
        if(error?.response?.status){

          if(enableBanner(error.config.url)) {

            switch (error?.response?.status) {

                case 400:
                    showError(error?.response?.data?.description || 'Si è verificato un errore');
                    break;

                case 401:
                  if(error.config.url === '/v3/login'){
                    showError(error?.response?.data?.description || 'Si è verificato un errore');
                    break;
                    
                  } else {
                    exitFromApplication();
                    break;
                  }
      
                case 403:
                  // exitFromApplication();
                  showError(error?.response?.data?.description || 'Si è verificato un errore');
                  break;
      
                case 404:
                  showError(error?.response?.data?.description || 'Si è verificato un errore');
                  break;
      
                case 500: 
                  
                  showError(error?.response?.data?.description || 'Si è verificato un errore');
                  break;
      
                default:
                  showError(error?.response?.data?.description || 'Si è verificato un errore');
                  break;
                  
            }
          }
            // errori generici
        } else if(error?.code){
          let connection;
          // await getIsOnline().then(d => connection = d)
          connection = navigator.onLine;
            if(connection) {
              switch (error?.code) {
                 
                  case "ERR_NETWORK": // corse error and other general error
                  if(error?.config?.url === '/v3/account/forgotpasswordnew') {
                    showError('Utente non trovato')
                  }
                  else {
                    showError(error?.response?.data?.description || 'Si è verificato un errore');
                  }
                  break;
        
                  default:
                    return Promise.reject(error);
                }
            }
            else if(error?.code === 'ERR_NETWORK') {
              if(enableBannerNoConnection(error?.config?.url)) {
                let message: string = messageBannerNoConnection(error?.config?.url);
                showErrorNoConnection(message);
              }
            }
        }

        // Registrazione: 416 (range card esaurito) e 404 (nessun range attivo) vengono
        // gestiti dalla schermata a tutto schermo in signup.tsx, quindi l'errore
        // deve arrivare a registerUser (il toast sopra resta comunque visibile).
        const errStatus = error?.response?.status;
        if ((errStatus === 416 || errStatus === 404) &&
            error?.config?.url?.includes('registerUserAndCustomer')) {
          return Promise.reject(error);
        }
      }
    );

    // Rimuovo gli interceptor allo smontaggio, così non se ne accumulano
    // più copie (che causavano toast duplicati)
    return () => {
      api.interceptors.request.eject(requestInterceptorId);
      api.interceptors.response.eject(responseInterceptorId);
    };
  }, []);

  // Indica se bisogna far uscire il banner di errore dell' interceptor oppure no (perchè gestisce gli errori il componente)
  // in base all' url 
  function enableBanner(url: string): boolean {
    return (
      !url.includes('v3/account/checkRequestCode') &&
      !url.includes('/v3/account/changeForgottenPassword')
    )
  }

  // Indica se bisogna far uscire il banner di "Assenza connessione"
  function enableBannerNoConnection(url: string): boolean {
    return (
      url === '/v3/account/forgotpasswordnew' ||
      url === '/v3/account/changeForgottenPassword' ||
      url === '/v3/login' ||
      url === '/v3/account/registerUserAndCustomer' ||
      url === '/v3/account/addOrCreateCustomer' ||
      url === '/v3/account/profile' ||
      url === '/v3/account/changepassword' ||
      url === '/v3/customer/setprivacy' 

    )
  }

  function messageBannerNoConnection(url: string): string {
    let message: string = 'Per eseguire l\'operazione, bisogna essere connessi ad internet.';
    switch (url) {
      case '/v3/login' :
        message = 'Per effettuare il login, bisogna essere connessi ad internet.'
        break;
    }
    return message
  }

      return (
        <>
        { statusLoader ?
          <LoadingSpinner show={statusLoader} />
          :
          <></>
        }
        <Toast ref={toast} position="top-center"/>
        </>
        
        );
};